import { FC } from "react";
import { IconPropsType } from ".";

export const DownloadDocument: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 1V5.5M9.5 5.5L7 2.83333M9.5 5.5L12 2.83333"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3.5V3.5C4.17157 3.5 3.5 4.17157 3.5 5V13C3.5 14.1046 4.39543 15 5.5 15H10.5C11.6046 15 12.5 14.1046 12.5 13V6"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6 8.5H10"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7 11.5H9"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
